import { onPath } from '../utils/path';
import Glide from '@glidejs/glide';
import { selectOne, addClass, hasClass, removeClass, setDisable } from '../utils/dom-utils';

onPath('/interactive-tour', () => {
  let didResize = false
  let initialConsumed = false
  let initialIndex = 0

  let previousIndex = 0

  const slides = [
    {
      eventName: 'interactive-tour-step-one',
      name: 'Step One',
      stepId: '#step-one',
      points: [
        {
          title: 'Your Visitors will Love Live Chat',
          copy: 'Give people the answers they need, fast. Live chat is quicker than calling, easier than email, and the only online channel that offers in-context support.',
          dotPosition: 'bottom-right',
          xOffset: 350,
          yOffset: 260,
        },
      ],
    },
    {
      eventName: 'interactive-tour-step-two',
      name: 'Step Two',
      stepId: '#step-two',
      points: [
        {
          title: 'Automated Engagement',
          copy: 'With targeted chat rules, you can pop open your chatbox and turn every visitor into an opportunity. Start the conversation based on rules you set, such as campaign, referral source, or the visitor’s city.',
          dotPosition: 'centre-right',
          xOffset: 185,
          yOffset: 80,
        },
      ],
    },
    {
      eventName: 'interactive-tour-step-three',
      name: 'Step Three',
      stepId: '#step-three',
      points: [
        {
          title: 'Optimized for mobile',
          copy: 'Did you know that more web traffic occurs on mobile devices than on desktop browsers? We did, so we designed your chatbox to excel on smartphones.',
          dotPosition: 'centre-left',
          xOffset: -205,
          yOffset: 80,
        },
      ],
    },
    {
      eventName: 'interactive-tour-step-four',
      name: 'Step Four',
      stepId: '#step-four',
      points: [
        {
          title: 'After-Hours Contact Form',
          copy: 'Hide your chatbox when you’re not around or automatically flip it into a contact form so your visitors can ask their questions over email.',
          dotPosition: 'centre-right',
          xOffset: 185,
          yOffset: 80,
        },
      ],
    },
    {
      eventName: 'interactive-tour-step-five',
      name: 'Step Five',
      stepId: '#step-five',
      points: [
        {
          title: 'Install in No Time',
          copy: 'Setting up your chatbox is as simple as copy & paste. All you need is access to your website’s HTML (or access to the person who does). No coding required.',
          dotPosition: 'centre-right',
          xOffset: -380,
          yOffset: 50,
        },
      ],
    },
    {
      eventName: 'interactive-tour-step-six',
      name: 'Step Six',
      stepId: '#step-six',
      points: [
        {
          title: 'Chat Only Where You Need It',
          copy: 'Install your chatbox on some pages or all of them. You control where it goes, and even who sees it by hiding the chatbox for out-of-region visitors or blocking IP addresses.',
          dotPosition: 'centre-right',
          xOffset: -340,
          yOffset: 190,
        },
      ],
    },
    {
      eventName: 'interactive-tour-step-seven',
      name: 'Step Seven',
      stepId: '#step-seven',
      points: [
        {
          title: 'Easy to Customize',
          copy: 'Pick your button styling and chatbox colors or choose from our dozens of options, including Dark Mode and Seasonal Themes.',
          dotPosition: 'centre-left',
          xOffset: 60,
          yOffset: 10,
        },
      ],
    },
    {
      eventName: 'interactive-tour-step-eight',
      name: 'Step Eight',
      stepId: '#step-eight',
      points: [
        {
          title: 'Accessible to All & ADA-Compliant',
          copy: 'Offer support to people with disabilities with the help of our high-contrast color palettes and other accessibility features. We test our chatbox with 3rd-party auditors to ensure we maintain a WCAG 2.0 AA rating. Adding accessible live chat is a great way to stay compliant with Section 508 of the Americans with Disabilities Act and other legal standards.',
          dotPosition: 'bottom-left',
          xOffset: 320,
          yOffset: 160,
        },
      ],
    },
    {
      eventName: 'interactive-tour-step-nine',
      name: 'Step Nine',
      stepId: '#step-nine',
      points: [
        {
          title: 'Field Chats from Your Desk or On the Go with Olark Mobile',
          copy: 'Enjoy a speedy and full-featured console in your browser or reply on the fly. No one wants to feel chained to their desk all day, so we made Olark Mobile so you can stay available while you’re in a meeting, waiting in line at the post office, or hanging out after hours.',
          dotPosition: 'centre-left',
          xOffset: -205,
          yOffset: 70,
        },
      ],
    },
    {
      eventName: 'interactive-tour-step-ten',
      name: 'Step Ten',
      stepId: '#step-ten',
      points: [
        {
          title: 'Save Time with Shortcuts',
          copy: 'For those frequently asked questions and common links, you’ll love using our shortcuts. Add as many as you want and make them available to the whole team so you can speed them up and standardize responses.',
          dotPosition: 'bottom-right',
          xOffset: -215,
          yOffset: 204,
        },
      ],
    },
    {
      eventName: 'interactive-tour-step-eleven',
      name: 'Step Eleven',
      stepId: '#step-eleven',
      points: [
        {
          title: 'Know Who You’re Talking To',
          copy: 'Recognize returning visitors and easily reference where they’re chatting from and which pages they’ve viewed so far on your site. ',
          dotPosition: 'centre-right',
          xOffset: 170,
          yOffset: 30,
        },
      ],
    },
    {
      eventName: 'interactive-tour-step-twelve',
      name: 'Step Twelve',
      stepId: '#step-twelve',
      points: [
        {
          title: 'Make the First Move',
          copy: 'Opportunity doesn’t knock, it chats. See everyone available on your site and scan for potential leads. When you find an engaged visitor, use Proactive Chat to start the conversation and offer your support.',
          dotPosition: 'top-right',
          xOffset: -470,
          yOffset: 115,
        },
      ],
    },
  ]

  window.location.hash = slides[0].stepId;
  const slideIdxFromHash = (hash) => slides.findIndex((slide) => slide.stepId == hash)

  const hash = window.location.hash
  console.log('hash : ', hash)

  if (hash && hash.length > 0) {
    const idx = slideIdxFromHash(hash)
    if (idx > 0) initialIndex = idx
  }

  // image carousel library
  let glide = new Glide('.glide', {
    animationTimingFunc: 'ease-in-out',
    startAt: 0,
    type: 'slide',
    animationDuration: 200,
  })

  const backButton = selectOne('#glide-control-back-button')
  const nextButton = selectOne('#glide-control-next-button')

  nextButton.addEventListener('click', () => {
    const currIdx = slideIdxFromHash(window.location.hash);

    if (currIdx >= slides.length - 1) {
      glide.go('>');
    } else {
      glide.go(`=${currIdx + 1}`);
    }
  })

  backButton.addEventListener('click', () => {
    const currIdx = slideIdxFromHash(window.location.hash);

    if (currIdx <= 0) {
      glide.go('<');
    } else {
      glide.go(`=${currIdx - 1}`);
    }
  })

  const updateProgressBar = () => {
    if (glide.index < previousIndex) {
      const swapTarget = 'tw-bg-olark-purple';
      const previousStepElement = selectOne(slides[glide.index].stepId)
      if (previousStepElement && hasClass(previousStepElement, swapTarget)) {
        removeClass(previousStepElement, swapTarget)
        addClass(previousStepElement, 'tw-bg-olark-gray')
      }
    } else {
      if (glide.index !== 0) {
        const swapTarget = 'tw-bg-olark-gray';
        const previousStepElement =  selectOne(slides[previousIndex].stepId)
        if (previousStepElement && hasClass(previousStepElement, swapTarget)) {
          removeClass(previousStepElement, swapTarget)
          addClass(previousStepElement, 'tw-bg-olark-purple')
        }
      }
    }

    previousIndex = glide.index
  }

  const disableOrEnableBackButton = () => {
    if (glide.index === 0) {
      addClass(backButton, 'tw-opacity-50')
      setDisable(backButton, true)
    } else {
      removeClass(backButton, 'tw-opacity-50')
      setDisable(backButton, false)
    }
  }

  const updatePageText = () => {
    const slide = slides[glide.index]
    const point = slide.points[0]

    const mobileTip = document.querySelector('.interactive-tour-mobiletip')
    const mobileTipTitle = document.querySelector('.interactive-tour-mobiletip h4')
    const mobileTipCopy = document.querySelector('.interactive-tour-mobiletip p')

    const pageNum = document.querySelector('.interactive-tour-pagenum-label')

    if (mobileTip) {
      // set tooltip offset
      mobileTip.style.top = `calc(50% + ${point.yOffset}px)`
      mobileTip.style.left = `calc(50% + ${point.xOffset}px)`

      // remove current dot position
      mobileTip.classList.remove('dot-top-right');
      mobileTip.classList.remove('dot-top-left');
      mobileTip.classList.remove('dot-centre-right');
      mobileTip.classList.remove('dot-centre-left');
      mobileTip.classList.remove('dot-bottom-right');
      mobileTip.classList.remove('dot-bottom-left');

      // set new dot position
      mobileTip.classList.add(`dot-${point.dotPosition}`)
    }

    if (mobileTipTitle) mobileTipTitle.textContent = `${point.title}`
    if (mobileTipCopy) mobileTipCopy.textContent = `${point.copy}`

    if (pageNum) pageNum.textContent = `Page: ${glide.index + 1} / ${slides.length}`

    // TODO: @bcongleton, handle events here with the following pseudocode:
    // event.fire(slide.eventName)
    analytics.track("Interactive Tour Viewed", {
      page: slide.eventName,
      name: slide.name
    });
  }

  const notifyResize = (e) => {
    if (!didResize) {
      didResize = true;
      analytics.track("Interactive Tour Resized", {
        height: window.innerHeight,
        width: window.innerWidth
      });
    }
  }

  const updateHashWithTourId = () => {
    window.location.hash = slides[glide.index].stepId.substring(1)
  }

  const handleUpdateSlide = () => {
    disableOrEnableBackButton()
    updatePageText()
    // updateProgressBar()

    if (!initialConsumed) {
      glide.go(`=${initialIndex}`)
      initialConsumed = true
    } else {
      updateHashWithTourId()
    }

  }

  glide.on('mount.after', () => {
    handleUpdateSlide()
    window.addEventListener('resize', (e) => notifyResize(e))
  })

  glide.on('run.after', () => {
    handleUpdateSlide()
    const finishButton = selectOne('#finish-tour-button')

    if ((slides.length - 1) === glide.index) {
      addClass(nextButton, 'hidden')
      removeClass(finishButton, 'hidden')
    } else {
      addClass(finishButton, 'hidden')
      removeClass(nextButton, 'hidden')
    }
  })

  glide.mount()

});
